import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { ShiftType } from '../../../../../../../store/api/shifts-api';
import gridStyles from '../shifts-grid.module.css';
import { getShiftStatus } from '../shifts-helpers';

const calcDayShift = (shift: ShiftType, day: string, rowWidth: number) => {
  const from = dayjs(shift.start_time);
  const to = dayjs(shift.end_time);

  const isRender = from.format('HH') === dayjs(day).format('HH');
  const timeToWidth = Math.abs((to.diff(from, 'minute') / 60) * rowWidth);
  const leftOffset = (rowWidth / 60) * Number(from.get('m'));

  return { isRender, timeToWidth, leftOffset };
};

const calcNightShift = (shift: ShiftType, rowWidth: number, timeToWidth: number, day: string) => {
  const maxWidth = rowWidth * 24;
  const from = dayjs(shift.start_time);
  const to = dayjs(shift.end_time);

  const hoursOffsetPx = Number(from.get('h')) * rowWidth;
  const minutesOffsetPx = (rowWidth / 60) * Number(from.get('m'));

  const availableWidth = maxWidth - hoursOffsetPx - minutesOffsetPx;

  const isCutRight = dayjs(day).format('YYYY-MM-DD') === from.format('YYYY-MM-DD');

  if (isCutRight) {
    return {
      timeToWidth: timeToWidth > availableWidth ? availableWidth - 1 : timeToWidth,
      isRender: from.format('DD HH') === dayjs(day).format('DD HH'),
    };
  } else {
    const width = to.get('h') * rowWidth + (rowWidth / 60) * to.get('m');
    return {
      isRender: to.format('DD HH') === dayjs(day).format('DD HH'),
      timeToWidth: width,
      leftOffset: -width,
    };
  }
};

const format = 'HH:mm';

interface Props {
  shift?: ShiftType;
  date: string;
}

export const useShiftsGridDaily = ({ date, shift }: Props) => {
  const [rowWidth, setRowWidth] = useState<number>(35);

  useEffect(() => {
    const handleResize = () => {
      const cols: HTMLDivElement[] = Array.from(document.querySelectorAll(`.${gridStyles.header}`));
      const rowWidth = cols[1]?.clientWidth;

      setRowWidth(rowWidth);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!shift) {
    return {
      isRender: false,
      timeToWidth: 0,
      range: '',
      from: dayjs(),
      to: dayjs(),
      income: undefined,
      outcome: undefined,
      leftOffset: 0,
    };
  }
  const from = dayjs(shift.start_time);
  const to = dayjs(shift.end_time);
  const range = `${from.format(format)} - ${to.format(format)}`;

  let { isRender, leftOffset, timeToWidth } = calcDayShift(shift, date, rowWidth);

  const status = getShiftStatus(shift);
  // const isNightShift = from.format('DD') !== to.format('DD');

  // if (isNightShift) {
  const {
    isRender: isRenderNight,
    leftOffset: leftOffsetNight,
    timeToWidth: timeToWidthNight,
  } = calcNightShift(shift, rowWidth, timeToWidth, date);

  isRender = isRenderNight;
  leftOffset = leftOffsetNight || leftOffset;
  timeToWidth = timeToWidthNight;
  // }

  return {
    isRender,
    timeToWidth,
    range,
    leftOffset,
    status,
  };
};
